var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},_vm._l((_vm.cards),function(card){return _c('v-col',{key:card.title,attrs:{"lg":"3","md":"4","sm":"6","cols":"12"}},[_c('OfferCard',{attrs:{"src":card.image,"title":card.title}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }